import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PicklistService } from "../../services/administration/picklist/picklist.service";
import { IPicklistFieldsData } from "../../interfaces/administration/picklistFieldsData";

@Component({
  selector: "app-edit-field",
  templateUrl: "./edit-field.component.html",
  styles: [
    `
      .button-container {
        display: flex !important;
        justify-content: space-between !important;
        margin: 10px 0px 0px 0px;
      }
    `,
  ],
})
export class EditFieldComponent implements OnInit, OnChanges {
  @Input() field!: IPicklistFieldsData;
  @Input() picklists: IPicklistFieldsData[] = [];
  @Output() fieldUpdated = new EventEmitter<IPicklistFieldsData>();
  @Output() formClosed = new EventEmitter<void>();

  form: FormGroup;
  isLoading = false;
  validationMessages: string[] = [];

  constructor(
    private fb: FormBuilder,
    private picklistService: PicklistService
  ) {
    this.form = this.fb.group({
      fieldName: ["", Validators.required],
      parentPicklist: [0],
    });
  }

  ngOnInit() {
    if (this.field) {
      this.form.patchValue({
        fieldName: this.field.name,
        parentPicklist: this.field.parentPicklistFieldsId || 0,
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["field"] && !changes["field"].firstChange) {
      this.form.patchValue({
        fieldName: this.field!.name,
        parentPicklist: this.field.parentPicklistFieldsId || 0,
      });
    }
  }

  onSubmit() {
    if (this.form.invalid) {
      this.validationMessages.push("Field name is required.");
      return;
    }
    this.validationMessages = [];
    this.isLoading = true;
    const updatedField: IPicklistFieldsData = {
      ...this.field,
      name: this.form.value.fieldName,
      parentPicklistFieldsId:
        this.form.value.parentPicklist === 0
          ? null
          : this.form.value.parentPicklist,
    };

    this.picklistService.updateField(updatedField).subscribe({
      next: (result) => {
        this.fieldUpdated.emit(result);
        this.isLoading = false;
      },
      error: () => {
        this.validationMessages.push(
          "An error occurred while updating the field."
        );
        this.isLoading = false;
      },
    });
  }

  cancel() {
    this.formClosed.emit();
  }
}
